
import { Container, Row, Col } from "react-bootstrap";
import nush from "../assets/img/Nush.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div>
                <h1>{`Hi! I'm Nushwa`} <span data-period="1000" ><span className="wrap">Web Developer</span></span></h1>
                  <p> I am ready to take on new challenges and contribute to the development of engaging websites. 
                  I am open to exciting opportunities and collaborations, 
                  so let's connect and explore how I can add value to your web development needs.</p>
                  
                  
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5} className="text-center text-xl-end order-md-1">
            
                <div>
                  <img className="header-image" src={nush} alt="Header Img"/>
                </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
